export default __webpack_public_path__ + "static/media/ad__amp__d_offer_light.8679a8fc.png";